import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import firebase from 'firebase/compat/app';
// import DatetimePicker from 'vuetify-datetime-picker'

import CountryFlag from 'vue-country-flag'
Vue.component('country-flag', CountryFlag)

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);


Vue.config.productionTip = false


let app = '';
firebase.auth().onAuthStateChanged(user => {
  if(!app){
    app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
  }
});
